import React from 'react';

interface PopupProps {
  onClose: () => void;
  liveUrl?: string | null;
}

const Popup: React.FC<PopupProps> = ({ onClose, liveUrl }) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="popup-overlay" onClick={handleBackdropClick}>
      <div className="popup-content glass-panel" role="dialog" aria-modal="true">
        <span className="popup-kicker">Acesso rápido</span>
        <h2 className="popup-title">Entre na sala de sinais ao vivo</h2>
        <p className="popup-text">
          Acompanhe as entradas do dia, orientações práticas e avisos mais
          importantes em um único ponto de acesso.
        </p>
        <div className="popup-actions">
          <a
            className="primary-button"
            href={liveUrl || "#"}
            target={liveUrl ? "_blank" : undefined}
            rel={liveUrl ? "noopener,noreferrer" : undefined}
          >
            Entrar agora
          </a>
          <button className="popup-close" onClick={onClose}>
            Continuar no site
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
